module.exports = __webpack_public_path__ + "img/story-18-3.jpeg";